import script from "./DocumentDownloadModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentDownloadModal.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentDownloadModal.vue?vue&type=style&index=0&id=7d1199fd&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d1199fd"]])

export default __exports__